import { render, staticRenderFns } from "./PrepaidExpenses.vue?vue&type=template&id=2b1daa5c&lang=pug"
import script from "./PrepaidExpenses.vue?vue&type=script&lang=js"
export * from "./PrepaidExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports